import styled from "styled-components";

const StyledLink = styled.a`
  color: #58585f;
  font-size: 14px;
  font-weight: 400;
  padding: 0 10px;
`;
const StyledTitle = styled.span`
  color: #58585f;
  font-size: 14px;
  font-weight: 400;
  padding: 0 10px;
  &::before {
    content: none !important;
    display: none !important;
  }
`;

const Breadcrumb = ({
  parent,
  sub,
  subTitle,
  subChild,
  detailsubChild,
  noBreadcrumb,
  id,

  // 각 수준별로 링크 활성화 여부 제어
  isSubLinkActive = true,
  isSubTitleLinkActive = true,
  isSubChildLinkActive = true,
}) => {
  // 다음 단계가 undefined이면 현재 단계 링크 비활성화
  const effectiveSubLinkActive =
    subTitle === undefined ? false : isSubLinkActive;
  const effectiveSubTitleLinkActive =
    subChild === undefined ? false : isSubTitleLinkActive;
  const effectiveSubChildLinkActive =
    detailsubChild === undefined ? false : isSubChildLinkActive;

  // 메인 카테고리 URL 생성 함수
  const getSubUrl = () => {
    if (sub === "로그인") return "/login/";
    if (sub === "장바구니") return "/shop-cart/";
    if (sub === "마이페이지") return "/mypage/order/";
    if (sub === "환경활동") return "/environment/about/";
    if (sub === "상품구매") return "/products/";
    if (sub === "ESG자료실") return "/esg-guide/";
    if (sub === "공지사항") return "/csboard/notice/";
    if (sub === "맞춤제작") return "/customizing/customizing-products/";
    if (sub === "소량인쇄") return "/customizing/print/";

    // if (sub === "결제")

    return "/";
  };

  // 서브 타이틀 URL 생성 함수
  const getSubTitleUrl = () => {
    if (sub === "상품구매") {
      return `/products/${encodeURIComponent(id)}/`;
    }

    if (sub === "ESG자료실") {
      if (subTitle === "ESG 환경뉴스") return "/esg-guide/news/";
      if (subTitle === "ESG 뉴스레터") return "/esg-guide/letter/";
      //포장재 인증정보는 상세 없으므로 생략
      if (subTitle === "소재와 포장재") return "/esg-guide/blog/package/";
      if (subTitle === "제작사례 & 포장재리뷰") return "/esg-guide/blog/make/";

      return `/esg-guide/`;
    }

    if (sub === "고객센터") {
      return `/csboard/notice/`;
    }

    if (sub === "맞춤제작") {
      return `/customizing/portfolio/`;
    }

    return "/";
  };

  // 서브 차일드 URL 생성 함수
  const getSubChildUrl = () => {
    if (sub === "상품구매") {
      return `/products/${encodeURIComponent(id)}/${encodeURIComponent(
        subChild
      )}/`;
    }

    return "/";
  };

  return (
    <>
      <div className={`page-header breadcrumb-wrap ${noBreadcrumb}`}>
        <div className="container">
          <div className="breadcrumb">
            {parent && (
              <StyledLink href="/">
                <a>{parent}</a>
              </StyledLink>
            )}

            {sub?.trim() && (
              <>
                {effectiveSubLinkActive ? (
                  <>
                    &gt;
                    <StyledLink href={getSubUrl()}>
                      <a>{sub}</a>
                    </StyledLink>
                  </>
                ) : (
                  <>
                    &gt; {"\u00A0\u00A0"}
                    {sub}
                  </>
                )}
              </>
            )}

            {subTitle?.trim() && (
              <>
                {effectiveSubTitleLinkActive ? (
                  <>
                    &gt;
                    <StyledLink href={getSubTitleUrl()}>
                      <a>{subTitle}</a>
                    </StyledLink>
                  </>
                ) : (
                  <>
                    &gt; {"\u00A0\u00A0"}
                    {subTitle}
                  </>
                )}
              </>
            )}

            {subChild?.trim() && (
              <>
                {effectiveSubChildLinkActive ? (
                  <>
                    &gt;
                    <StyledLink href={getSubChildUrl()}>
                      <a>{subChild}</a>
                    </StyledLink>
                  </>
                ) : (
                  <>
                    &gt; {"\u00A0\u00A0"}
                    {subChild}
                  </>
                )}
              </>
            )}

            {detailsubChild ? (
              <>
                &gt;
                <StyledTitle aria-current="page">{detailsubChild}</StyledTitle>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
